import * as React from 'react';
import { Label, ILabelProps } from './Label';

type TStaticProps = 'title' | 'bgColor';

export type ILabelDynamicProps = Omit<ILabelProps, TStaticProps>;
export type ILabelStaticProps = Pick<ILabelProps, TStaticProps>;

/**
 *
 * @description HOC для создание лейбла продвижения (топ, премиум и т.д.)
 * @param staticProps - статические данные лейбла
 * @param dynamicProps - динамические данные лейбла
 */
export const createLabel = (staticProps: ILabelStaticProps): React.FunctionComponent<ILabelDynamicProps> =>
  function LabelWrapper(dynamicProps) {
    return <Label {...dynamicProps} {...staticProps} />;
  };
